import React from 'react';
import TitlePage from './../../components/page/title';
import NavBar from './../../components/NavBar';
import Home from './../../screens/Home';
import './Confighome.scss';
import { configurationService, podcastService, stationService, tagService } from '../../services';
import { Button, Row, Col, Form, Modal, Image, InputGroup } from 'react-bootstrap';
import ReactTags from 'react-tag-autocomplete';
import toast from 'toasted-notes'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEraser } from '@fortawesome/free-solid-svg-icons';


class Confighome extends Home{

  constructor(props) {
      super(props)
      this.state = {
        configuration: { station: { id: "" }, podcast1: { id: "" }},
        showconfirm: false,
        stations: [],
        podcast: [],
        tags: [],
        locales: [],
        locale: 'es',
      };
  
      this.reactTags = React.createRef();
      this.reactPrograms = React.createRef();
      this.reactTagsCharacter = React.createRef();
      this.reactTagsStation = React.createRef();
      this.reactTagsExclusive = React.createRef();
      this.reactTagsTrend = React.createRef();
  
      this.loadInitialData();
    }
  
    loadInitialData() {
      this.callSearch(this.state.locale);
      this.callLanguage();
      this.callStations();
      this.callPodcast();
      this.callDestinations();
      this.callCharacters();
      this.callTravels();
      this.callPrograms();
    }
  
    callLanguage() {
      configurationService.language((data, error) => {
        if (data) this.setState({ locales: data });
      });
    }
  
    callPodcast() {
      podcastService.all((data, error) => {
        if (data) {
          const podcasts = data.filter(podcast => !podcast.isPoi);
          this.setState({ podcast: podcasts });
        }
      });
    }

    callDestinations() {
      podcastService.tagtype("DESTINATION", (datarows, error) => {
        if (datarows) this.setState({ tags: datarows });
      });
    }

    callCharacters(){
      podcastService.tagtype("CHARACTER", (datarows, error) => {
        if (datarows) this.setState({ historicCharacters: datarows });
      });
    }

    callTravels(){
      podcastService.tagtype("TRAVEL_CATEGORY", (datarows, error) => {
        if (datarows) this.setState({ travelCategory: datarows });
      });
    }
  
    callStations() {
      stationService.all((data, error) => {
        if (data) this.setState({ stations: data });
      });
    }

    callPrograms() {
      podcastService.programs((datarows, error) => {
        if (datarows) this.setState({ programs: datarows });
      });
    }
  
    callSearch(locale) {
      configurationService.home(locale, (data, error) => {
        if (data) {
          this.setState({ configuration: data });
        } else {
          toast.notify("No se ha encontrado la configuración por defecto", { position: 'top', duration: 5000 });
          this.setState({ buttonvisibles: false });
        }
      });
    }

   handleChangeLocale(event) {
     const locale = event.target.value
     this.setState({locale:locale});
     this.callSearch(locale);

   }

   handleChange(event) {
    const { name, value } = event.target;
    const configuration = { ...this.state.configuration };
  
    const resetFields = (index, fieldType) => {
      if (fieldType === 'podcast') {
        configuration[`urlSLide${index}`] = "";
        configuration[`tag${index}`] = null;
      } else if (fieldType === 'urlSLide') {
        configuration[`podcast${index}`] = null;
        configuration[`tag${index}`] = null;
      } else if (fieldType === 'tag') {
        configuration[`urlSLide${index}`] = "";
        configuration[`podcast${index}`] = null;
      }
    };
  
    const match = name.match(/(podcast|urlSLide|tag|image)(\d+)/);
    
    if (match) {
      const [, fieldType, index] = match;
  
      if (fieldType === "podcast") {
        configuration[`podcast${index}`] = { id: value };
        resetFields(index, 'podcast');
      } else if (fieldType === "urlSLide") {
        configuration[`urlSLide${index}`] = value;
        resetFields(index, 'urlSLide');
      } else if (fieldType === "tag") {
        configuration[`tag${index}`] = { id: value };
        resetFields(index, 'tag');
      } else if (fieldType === "image") {
        configuration[`image${index}`] = value;
      }
  
      this.setState({ configuration });
    } else if (name === "visibleApp") {
      configuration.station = { id: value };
      this.setState({ configuration });
    }
  }

    handleClickSave(event) {
      this.callSend();
    }

    onDelete (i) {
      const tags = this.state.configuration.tags.slice(0)
      tags.splice(i, 1)
      var configuration = this.state.configuration;
      configuration.tags = tags;
      this.setState({configuration:configuration});
    }

    onAddition (tag) {
      const tags = [].concat(this.state.configuration.tags, tag)
      var configuration = this.state.configuration;
      configuration.tags = tags;
      this.setState({configuration:configuration});
    }

    onDeleteProgram(i) {
      const tags = this.state.configuration.programs.slice(0)
      tags.splice(i, 1)
      var configuration = this.state.configuration;
      configuration.programs = tags;
      this.setState({configuration:configuration});
    }

    onAdditionProgram (tag) {
      const tags = [].concat(this.state.configuration.programs, tag)
      var configuration = this.state.configuration;
      configuration.programs = tags;
      this.setState({configuration:configuration});
    }

    onDeleteExclusive(i) {
      const tags = this.state.configuration.exclusives.slice(0)
      tags.splice(i, 1)
      var configuration = this.state.configuration;
      configuration.exclusives = tags;
      this.setState({configuration:configuration});
    }

    onAdditionExclusive (tag) {
      const tags = [].concat(this.state.configuration.exclusives, tag)
      var configuration = this.state.configuration;
      configuration.exclusives = tags;
      this.setState({configuration:configuration});
    }

    onDeleteTrend(i) {
      const tags = this.state.configuration.trends.slice(0)
      tags.splice(i, 1)
      var configuration = this.state.configuration;
      configuration.trends = tags;
      this.setState({configuration:configuration});
    }

    onAdditionTrend (tag) {
      const tags = [].concat(this.state.configuration.trends, tag)
      var configuration = this.state.configuration;
      configuration.trends = tags;
      this.setState({configuration:configuration});
    }

    onDeleteCharacter(i) {
      const tags = this.state.configuration.historicCharacters.slice(0)
      tags.splice(i, 1)
      var configuration = this.state.configuration;
      configuration.historicCharacters = tags;
      this.setState({configuration:configuration});
    }

    onAdditionCharacter(tag){
      const tags = [].concat(this.state.configuration.historicCharacters, tag)
      var configuration = this.state.configuration;
      configuration.historicCharacters = tags;
      this.setState({configuration:configuration});
    }

    onDeleteStation(i) {
      const tags = this.state.configuration.stations.slice(0)
      tags.splice(i, 1)
      var configuration = this.state.configuration;
      configuration.stations = tags;
      this.setState({configuration:configuration});
    }

    onAdditionStation (tag) {
      const tags = [].concat(this.state.configuration.stations, tag)
      var configuration = this.state.configuration;
      configuration.stations = tags;
      this.setState({configuration:configuration});
    }

  callSend (){

      let callback = (data, error) => {
        if (data) {
           this.setState({showconfirm:true});
        }
      }
      configurationService.edithome(this.state.configuration.id,this.state.configuration, callback);
  }

  validURL(str) {
    var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
      '(\\?[;&a-z\\d%_.~+\\/=-]*)?'+ // query string
      '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
    return !!pattern.test(str);
  }

  clearField = (fieldName, isSelect) => {
    this.setState(prevState => ({
      configuration: {
        ...prevState.configuration,
        [fieldName]: isSelect ? null : ""
      }
    }));
  };

  render () {
    
    return <>
      <NavBar user={this.state.user} callback={this.changeMenu}/>
      <div className="main">
         <TitlePage title="Definición de la home" newbutton={false} link=""  />
          <Row>
            <Col sm="12">
                <h5>Selecciona el idioma a modificar</h5>
            </Col>
            <Col sm="12">
                <Form.Group controlId="formTags">
                  <Form.Label></Form.Label>
                  <Form.Control as="select" name="podcast1" onChange={event => this.handleChangeLocale(event)} value={this.state.locale} >
                    {this.state.locales.map((locale,idx) => (
                        <option value={locale.locale}>{locale.locale}</option>
                    ))}
                  </Form.Control>
                </Form.Group>
            </Col>
          </Row>
         <Row>

              <Col sm="12">
                  <h4>Primer Slider</h4>
              </Col>
              <div sm="12" className="panelslider">
                <Row>
                  {Array.from({ length: 8 }).map((_, index) => {
                    const i = index + 1;
                    const imageKey = `image${i}`;
                    const podcastKey = `podcast${i}`;
                    const urlKey = `urlSLide1${i}`;
                    const tagKey = `tag1${i}`;

                    return (
                      <Col sm="3" key={i}>
                        <Row>
                          <Col sm="12">
                            <div className="paneImageUp">
                              <Image
                                src={this.state.configuration[imageKey]}
                                alt="image"
                                fluid
                                hidden={!this.validURL(this.state.configuration[imageKey])}
                              />
                            </div>
                            <Form.Label>Imagen</Form.Label>
                            <InputGroup>
                              <Form.Control
                                name={imageKey}
                                value={this.state.configuration[imageKey]}
                                onChange={event => this.handleChange(event)}
                              />
                              <button variant="outline-secondary" className="clean-button" onClick={() => this.clearField(imageKey, false)}><FontAwesomeIcon icon={faEraser} className="broom-icon" /></button>
                            </InputGroup>
                          </Col>

                          <Col sm="12">
                            <Form.Group controlId={`formPodcast${i}`}>
                            <Form.Label>Podcast</Form.Label>
                              <InputGroup>
                                <Form.Control
                                  as="select"
                                  name={podcastKey}
                                  onChange={event => this.handleChange(event)}
                                  value={
                                    this.state.configuration[podcastKey] != null &&
                                    this.state.configuration[podcastKey].id
                                  }
                                >
                                  <option value="">---</option>
                                  {this.state.podcast.map((podcast, idx) => (
                                    <option key={idx} value={podcast.id}>
                                      {podcast.title}
                                    </option>
                                  ))}
                                </Form.Control>
                                <button variant="outline-secondary" className="clean-button" onClick={() => this.clearField(podcastKey, true)}><FontAwesomeIcon icon={faEraser} className="broom-icon" /></button>
                                </InputGroup>
                            </Form.Group>
                          </Col>

                          <Col sm="12">- o -</Col>

                          <Col sm="12">
                            <Form.Group>
                            <Form.Label>URL</Form.Label>
                            <InputGroup>
                              <Form.Control
                                placeholder=""
                                name={urlKey}
                                value={this.state.configuration[urlKey]}
                                onChange={event => this.handleChange(event)}
                              />
                              <button variant="outline-secondary" className="clean-button" onClick={() => this.clearField(urlKey, false)}><FontAwesomeIcon icon={faEraser} className="broom-icon" /></button>
                              </InputGroup>
                            </Form.Group>
                          </Col>

                          <Col sm="12">- o -</Col>

                          <Col sm="12">
                            <Form.Group controlId={`formTag${i}`}>
                            <Form.Label>Tag</Form.Label>
                              <InputGroup>
                                <Form.Control
                                  as="select"
                                  name={tagKey}
                                  onChange={event => this.handleChange(event)}
                                  value={
                                    this.state.configuration[tagKey] != null &&
                                    this.state.configuration[tagKey].id
                                  }
                                >
                                  <option value="">---</option>
                                  {this.state.tags.map((tag, idx) => (
                                    <option key={idx} value={tag.id}>
                                      {tag.name}
                                    </option>
                                  ))}
                                </Form.Control>
                                <button variant="outline-secondary" className="clean-button" onClick={() => this.clearField(tagKey, true)}><FontAwesomeIcon icon={faEraser} className="broom-icon" /></button>
                                </InputGroup>
                            </Form.Group>
                          </Col>
                        </Row>
                      </Col>
                    );
                  })}
                </Row>
              </div>

              <Col sm="12">
                  <h4>Segundo Slider</h4>
              </Col>
              <div sm="12" className="panelslider">
                <Row>
                  {Array.from({ length: 8 }).map((_, index) => {
                    const i = index + 21;
                    const imageKey = `image${i}`;
                    const podcastKey = `podcast${i}`;
                    const urlKey = `urlSLide${i}`;
                    const tagKey = `tag${i}`;

                    return (
                      <Col sm="3" key={i}>
                        <Row>
                          <Col sm="12">
                            <div className="paneImageUp">
                              <Image
                                src={this.state.configuration[imageKey]}
                                alt="image"
                                fluid
                                hidden={!this.validURL(this.state.configuration[imageKey])}
                              />
                            </div>
                            <Form.Label>Imagen</Form.Label>
                            <InputGroup>
                              <Form.Control
                                name={imageKey}
                                value={this.state.configuration[imageKey]}
                                onChange={event => this.handleChange(event)}
                              />
                              <button variant="outline-secondary" className="clean-button" onClick={() => this.clearField(imageKey, false)}><FontAwesomeIcon icon={faEraser} className="broom-icon" /></button>
                              </InputGroup>
                          </Col>

                          <Col sm="12">
                            <Form.Group controlId={`formPodcast${i}`}>
                            <Form.Label>Podcast</Form.Label>
                              <InputGroup>
                                <Form.Control
                                  as="select"
                                  name={podcastKey}
                                  onChange={event => this.handleChange(event)}
                                  value={
                                    this.state.configuration[podcastKey] != null &&
                                    this.state.configuration[podcastKey].id
                                  }
                                >
                                  <option value="">---</option>
                                  {this.state.podcast.map((podcast, idx) => (
                                    <option key={idx} value={podcast.id}>
                                      {podcast.title}
                                    </option>
                                  ))}
                                </Form.Control>
                                <button variant="outline-secondary" className="clean-button" onClick={() => this.clearField(podcastKey, true)}><FontAwesomeIcon icon={faEraser} className="broom-icon" /></button>
                                </InputGroup>
                            </Form.Group>
                          </Col>

                          <Col sm="12">- o -</Col>

                          <Col sm="12">
                            <Form.Group>
                            <Form.Label>URL</Form.Label>
                            <InputGroup>
                              <Form.Control
                                placeholder=""
                                name={urlKey}
                                value={this.state.configuration[urlKey]}
                                onChange={event => this.handleChange(event)}
                              />
                              <button variant="outline-secondary" className="clean-button" onClick={() => this.clearField(urlKey, false)}><FontAwesomeIcon icon={faEraser} className="broom-icon" /></button>
                              </InputGroup>
                            </Form.Group>
                          </Col>

                          <Col sm="12">- o -</Col>

                          <Col sm="12">
                            <Form.Group controlId={`formTag${i}`}>
                            <Form.Label>Tag</Form.Label>
                              <InputGroup>
                                <Form.Control
                                  as="select"
                                  name={tagKey}
                                  onChange={event => this.handleChange(event)}
                                  value={
                                    this.state.configuration[tagKey] != null &&
                                    this.state.configuration[tagKey].id
                                  }
                                >
                                  <option value="">---</option>
                                  {this.state.tags.map((tag, idx) => (
                                    <option key={idx} value={tag.id}>
                                      {tag.name}
                                    </option>
                                  ))}
                                </Form.Control>
                                <button variant="outline-secondary" className="clean-button" onClick={() => this.clearField(tagKey, true)}><FontAwesomeIcon icon={faEraser} className="broom-icon" /></button>
                                </InputGroup>
                            </Form.Group>
                          </Col>
                        </Row>
                      </Col>
                    );
                  })}
                </Row>
              </div>


             <Col sm="12" className="tagsrow">
                  <Form.Group >
                    <Form.Label>Tipos de Viaje</Form.Label>
                    <ReactTags allowNew={true} className="tagsinput" ref={this.reactTags} tags={this.state.configuration.tags} suggestions={this.state.travelCategory} onDelete={this.onDelete.bind(this)} onAddition={this.onAddition.bind(this)} placeholderText="Etiquetas"/>
                  </Form.Group>
            </Col>
            <Col sm="12">
                 <Form.Group>
                   <Form.Label>Programas</Form.Label>
                   <ReactTags allowNew={false} className="tagsinput" ref={this.reactTagsFeature} tags={this.state.configuration.programs} suggestions={this.state.programs} onDelete={this.onDeleteProgram.bind(this)} onAddition={this.onAdditionProgram.bind(this)} placeholderText="Programas"/>
                 </Form.Group>
           </Col>
           <Col sm="12">
                 <Form.Group>
                   <Form.Label>Exclusivos Radio Viajera</Form.Label>
                   <ReactTags allowNew={false} className="tagsinput" ref={this.reactTagsExclusive} tags={this.state.configuration.exclusives} suggestions={this.state.programs} onDelete={this.onDeleteExclusive.bind(this)} onAddition={this.onAdditionExclusive.bind(this)} placeholderText="Exclusivos Radio Viajera"/>
                 </Form.Group>
           </Col>
           <Col sm="12">
                 <Form.Group>
                   <Form.Label>Destinos en Tendencia</Form.Label>
                   <ReactTags allowNew={false} className="tagsinput" ref={this.reactTagsTrend} tags={this.state.configuration.trends} suggestions={this.state.tags} onDelete={this.onDeleteTrend.bind(this)} onAddition={this.onAdditionTrend.bind(this)} placeholderText="Tendencias"/>
                 </Form.Group>
           </Col>
           <Col sm="12">
                 <Form.Group>
                   <Form.Label>Personajes de la Historia</Form.Label>
                   <ReactTags allowNew={false} className="tagsinput" ref={this.reactTagsCharacter} tags={this.state.configuration.historicCharacters} suggestions={this.state.historicCharacters} onDelete={this.onDeleteCharacter.bind(this)} onAddition={this.onAdditionCharacter.bind(this)} placeholderText="Personajes"/>
                 </Form.Group>
           </Col>
           <Col sm="12">
                 <Form.Group>
                   <Form.Label>Emisoras</Form.Label>
                   <ReactTags allowNew={false} className="tagsinput" ref={this.reactTagsStation} tags={this.state.configuration.stations} suggestions={this.state.stations} onDelete={this.onDeleteStation.bind(this)} onAddition={this.onAdditionStation.bind(this)} placeholderText="Emisoras"/>
                 </Form.Group>
           </Col>
           <Col sm="12">
               <Form.Group controlId="formTags">
                 <Form.Label>Radio de inicio</Form.Label>
                 <Form.Control as="select" name="station" onChange={event => this.handleChange(event)} value={this.state.configuration.station != null  && this.state.configuration.station.id} >
                   <option value="">---</option>
                   {this.state.stations.map((station,idx) => (
                       <option value={station.id}>{station.name}</option>
                   ))}
                 </Form.Control>
               </Form.Group>
           </Col>
         </Row>
         <Row>
             <Col className="text-right">
                 <Button variant="primary" className="" onClick={event => this.handleClickSave(event)}>Guardar</Button>
             </Col>
         </Row>
      </div>

      <Modal show={this.state.showconfirm} onHide={event => this.setState({showconfirm:false})}>
        <Modal.Header closeButton>
          <Modal.Title>configurationficacion enviada</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Row>
            <Col>
              <p>Se ha enviado la configurationficación correctamente</p>
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={event => this.setState({showconfirm:false})}>Cerrar</Button>
        </Modal.Footer>
      </Modal>
      </>
  };
}

export default Confighome;
